import React, { useState, useMemo } from 'react';
import { Box, Grid, TextField, MenuItem, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { useLocation } from 'react-router-dom';

const services = [
  'AC installation','AC repair','AC replacement','HVAC maintenance','Boiler services','Heat pump repair',
  'Furnace services','iWave furnace installation and service','Heater repair','Heater installation',
  'Green heating & cooling systems','High-velocity systems','Indoor air quality','Emergency HVAC',
  'Duct cleaning','Thermostat installation','Energy efficiency audits','Zoning system setup',
  'Commercial HVAC maintenance','Preventive maintenance plans'
];

const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
const isPhone = (v) => /^[0-9()\-\s+]{7,}$/.test(v);

export default function ContactForm({ compact=false }) {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: '', phone: '', email: '', address: '', serviceType: services[0], date: '', notes: '',
    utm_source: params.get('utm_source') || '', utm_medium: params.get('utm_medium') || '', utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '', utm_content: params.get('utm_content') || ''
  });

  const valid = form.name && isPhone(form.phone) && isEmail(form.email);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!valid) return;
    // TODO: integrate with your backend, Mailgun, Zapier, etc.
    // Example:
    // fetch('https://your-endpoint.example.com/leads', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(form) })
    setOpen(true);
  };

  return (
    <Box component="form" onSubmit={onSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}><TextField label="Full Name" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} required fullWidth /></Grid>
        <Grid item xs={12} md={6}><TextField label="Phone" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} required fullWidth /></Grid>
        <Grid item xs={12} md={6}><TextField label="Email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} required fullWidth /></Grid>
        <Grid item xs={12} md={6}><TextField label="Service Address" value={form.address} onChange={e=>setForm({...form, address:e.target.value})} fullWidth /></Grid>
        <Grid item xs={12} md={6}>
          <TextField select label="Service Type" value={form.serviceType} onChange={e=>setForm({...form, serviceType:e.target.value})} fullWidth>
            {services.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6}><TextField type="date" label="Preferred Date" value={form.date} onChange={e=>setForm({...form, date:e.target.value})} fullWidth InputLabelProps={{ shrink: true }} /></Grid>
        {!compact && <Grid item xs={12}><TextField label="Notes" value={form.notes} onChange={e=>setForm({...form, notes:e.target.value})} multiline minRows={3} fullWidth /></Grid>}

        {/* Hidden UTM fields */}
        <input type="hidden" name="utm_source" value={form.utm_source} readOnly />
        <input type="hidden" name="utm_medium" value={form.utm_medium} readOnly />
        <input type="hidden" name="utm_campaign" value={form.utm_campaign} readOnly />
        <input type="hidden" name="utm_term" value={form.utm_term} readOnly />
        <input type="hidden" name="utm_content" value={form.utm_content} readOnly />

        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary" disabled={!valid}>Submit</Button>
        </Grid>
      </Grid>

      <Dialog open={open} onClose={()=>setOpen(false)}>
        <DialogTitle>Request Received</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Thanks {form.name}! We’ve logged your request for {form.serviceType}. Our team will call {form.phone} and email {form.email} to confirm.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setOpen(false)} autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
